<template v-slot="props">
  <div v-if="isTaskName">
    <span class="invisible">{{ taskName.id }}</span>
    <span v-if="canEditTaskName">
      <a href="#" title="View/Edit Task Name" @click.prevent="handleEditTaskName">{{ taskName.name }}</a>
    </span>
    <span v-else>
      {{ taskName.name }}
    </span>
  </div>
</template>
<script>
import Permissions from 'src/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    isTaskName() {
      return !!(this.data && this.data.name && this.data.id)
    },
    taskName() {
      return this.data
    },
    canEditTaskName() {
      return this.$can('edit', Permissions.TASK_NAMES)
    }
  },
  methods: {
    handleEditTaskName() {
      this.$eventHub.$emit('show-modal-1', 'Task Name', {id: this.taskName.id})
    }
  }
}
</script>
